import { withLoginUser } from 'src/api/user'
import { asPage } from 'src/components/hoc/asPage'
import { CompanyPersonasIndexPage } from 'src/compositions/Profile/Persona'

export const CompanyPersonasIndex = withLoginUser(({ user }) => (
  <CompanyPersonasIndexPage user={user} />
))

export default asPage(CompanyPersonasIndex, { pageTitle: 'ペルソナ登録' })
